import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NationalityModel} from '../../../../shared/dto/nationality.model';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NationalityService} from '../../../../shared/service/nationality.service';
import swal from "sweetalert2";
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-nationality-popup',
  templateUrl: './nationality-popup.component.html',
  styleUrls: ['./nationality-popup.component.scss']
})
export class NationalityPopupComponent implements OnInit {
  public nationalityPopup: FormGroup;
  @Input() nationalityMgtCopy_: NationalityModel[];
  nationalityMgt: any;
  public selectedState: string;
  ActionMode = ActionMode;
  public code: string;
  public description: string;
  public selectedMode;
  public href: string = "";

  public nationalityDTO: NationalityModel [] = [];


  constructor(public activeModal: NgbActiveModal,
              public nationalityService: NationalityService,
              public tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.nationalityPopup = new FormGroup({
      code: new FormControl(null,Validators.required),
      description: new FormControl(null,Validators.required),
      states: new FormControl(null,Validators.required),
    });
    this.href = this.router.url;
    this.nationalityMgt = {...this.nationalityMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.nationalityPopup.disable();
    }
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';

    // if (!this.employeePopup.valid) {
    //   isValid = false;
    //   errorMessage = 'Please, Fill the form Data...!'
    // }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          const nationalityDTO: NationalityModel = new NationalityModel(
            this.code,
            this.description,
            this.selectedState,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );
          this.nationalityService.saveNationality(nationalityDTO).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }

}
